'use client';
import React from 'react';
import HeroSearchBar from './HeroSearchBar';
import { useLanguage } from '@/context/LanguageContext';

export default function ServicesHero() {
  const { t } = useLanguage();

  return (
    <section className="relative bg-primary overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 right-0 w-96 h-96 rounded-full bg-white/20 translate-x-1/3 -translate-y-1/3" />
        <div className="absolute bottom-0 left-0 w-64 h-64 rounded-full bg-white/10 -translate-x-1/4 translate-y-1/4" />
      </div>
      <div className="relative max-w-screen-2xl mx-auto px-6 lg:px-8 xl:px-10 2xl:px-16 py-16 md:py-24">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 bg-white/15 text-white text-xs font-medium px-3 py-1.5 rounded-full mb-4">
            <span className="w-1.5 h-1.5 rounded-full bg-accent animate-pulse" />
            {t('hero.badge')}
          </div>
          <h1 className="font-display text-4xl md:text-5xl font-bold text-white leading-tight mb-4">
            {t('hero.title1')}<br />
            <span className="text-accent">{t('hero.title2')}</span>
          </h1>
          <p className="text-white/80 text-lg mb-8 font-body">{t('hero.subtitle')}</p>
          <HeroSearchBar />
        </div>
      </div>
    </section>
  );
}